export type Testimonial = {
  quote: string;
  name: string;
  role: string;
  company: string;
  country: string;
  avatar: string;
};

/** Client testimonials, verbatim from the doimpo collab connection deck. */
export const TESTIMONIALS: Testimonial[] = [
  {
    quote:
      "Working with Doimpo gave us a partner who understood both our brand and the business behind it. They were responsive, solution-oriented and committed to translating our vision into a professional digital presence. What stood out was their willingness to go beyond simply delivering a project and actually think with us as a business partner.",
    name: "Zaid Al Ali",
    role: "Founder",
    company: "The Zphoenix Events",
    country: "Jordan",
    avatar: "/media/images/testimonials/zaid-al-ali.webp",
  },
  {
    quote:
      "Doimpo Collab and David Enoch did more than just build my website — they helped bring my vision to life. They understood what I wanted to communicate and translated it into a digital presence that truly represents my journey and work.",
    name: "Amey Marathe",
    role: "International F&B Consultant",
    company: "Chef Amey Marathe",
    country: "India",
    avatar: "/media/images/testimonials/amey-marathe.webp",
  },
  {
    quote:
      "Doimpo didn't feel like an external agency. They understood what we were trying to build and helped us with refreshed logo and brand visual identity. Now we are future safe.",
    name: "John Kiran Garapati",
    role: "Founder",
    company: "TreviaEV",
    country: "India",
    avatar: "/media/images/testimonials/john-kiran-garapati.webp",
  },
];
